var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

$(".XXXXX__slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    arrows: true,
    dots: false,
    speed: 300,
    centerPadding: '20px',
    infinite: true,
    autoplaySpeed: 5000,
    autoplay: false,
    responsive: [
    {
      breakpoint: 440,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
      }
    },
  ]
});

$(".XXXXX__slider").slickLightbox({
    itemSelector: "a",
    navigateByKeyboard: true
});



$(document).ready(function() {
   $('.abz-logo-slider').owlCarousel({
         loop: true,
         nav : false,
         dots: true,
         items: 5,
         autoHeight:true,
         responsiveClass:true,
         responsive:{
          0:{
            items:2,
            nav:false
        },
        480:{
            items:3,
            nav:false
        },
         1024:{
            items:4,
            nav:false
        },
        1025:{
            items:5,
            nav:false
        }
        }
      });
   });